import Vue from 'vue'
import router from '@/router'
import { TagList, fetchCaseList, pay, payLiantong, getHotKeyword, getBannerList, getBannerPage, getQualityList, getCommercialList, getModulesList, getSearch, getSearchSolution, getChannelByCode, fetchCasePage, fetchCaseInfo, getSolutionDetail } from '@/services/home'
import { handleError } from '@/utils/util'

const state = {
  tagList: [],
  caseList: [],
  loadingId: '',
  hotKeyword: [],
  bannerList: [],
  bannerPage: [],
  qualityList: [],
  commercialList: [],
  modules: [],
  searchResult: [],
  solutionResult: [],
  channelByCode: {},
  casePage: {
    list: [],
    page: '',
    count: ''
  },
  caseInfo: {
    labels: ''
  },
  searchValue: '',
  code: '',
  solutionInfo: {}
}

const mutations = {
  updateTagList(state, { payload }) {
    state.tagList = payload
  },
  updateCaseList(state, { payload }) {
    state.caseList = payload
  },
  updateCasePage(state, { payload }) {
    state.casePage.page = payload.page
    state.casePage.count = payload.count
    payload.list.map(item => {
      state.casePage.list.push(item)
    })
  },
  initCasePage(state) {
    state.casePage = {
      list: [],
      page: '',
      count: ''
    }
  },
  updateCaseInfo(state, { payload }) {
    state.caseInfo = payload
  },
  updateLoadingId(state, { payload }) {
    state.loadingId = payload
  },
  updateHotKeyword(state, { payload }) {
    state.hotKeyword = payload
  },
  updateBannerList(state, { payload }) {
    state.bannerList = payload
  },
  updateBannerPage(state, { payload }) {
    state.bannerPage = payload
  },
  updateQualityList(state, { payload }) {
    state.qualityList = payload
  },
  updateCommercialList(state, { payload }) {
    state.commercialList = payload
  },
  updateModulesList(state, { payload }) {
    state.modules = payload
  },
  updateSearchResult(state, { payload }) {
    state.searchResult = payload
  },
  updateSolutionResult(state, { payload }) {
    state.solutionResult = payload
  },
  updateChannelByCode(state, { payload }) {
    state.channelByCode = payload
  },
  updateSearchValue(state, searchValue) {
    state.searchValue = searchValue
  },
  updateCode(state, payload) {
    state.code = payload
  },
  updateSolutionInfo(state, { payload }) {
    state.solutionInfo = payload
  }
}

const actions = {
  async fetchTagList({ commit }, payload) {
    const response = await TagList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateTagList', payload: response.data || [] })
    }
  },
  async fetchCaseList({ commit }, payload) {
    const response = await fetchCaseList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateCaseList', payload: (response.data) || [] })
    }
  },
  async fetchCasePage({ commit }, payload) {
    const response = await fetchCasePage(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateCasePage', payload: response.data || [] })
    }
  },
  async fetchCaseInfo({ commit }, payload) {
    const response = await fetchCaseInfo(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateCaseInfo', payload: (response.data && response.data) || [] })
    }
  },
  async getQualityList({ commit }, payload) {
    const response = await getQualityList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateQualityList', payload: (response.data) || [] })
    }
  },
  async pay({ commit }, { id, value, callback, type }) {
    const publishType = localStorage.getItem('publishType')
    const townId = localStorage.getItem('townId')
    const accessToken = localStorage.getItem('access-token')
    const { $confirm, $message } = Vue.prototype

    if (!publishType || !townId || !id) {
      $message.error('参数缺失')
      return
    }
    commit({
      type: 'updateLoadingId',
      payload: id
    })
    const response = value === 2 ? await payLiantong({ applyId: id, townId, publishType }) : await pay({ applyId: id, townId, publishType })
    if (response && response.code === '0') {
      $confirm(value === 2 ? '请前往联通管理后台发布应用' : '请前往APP运营管理平台发布应用', '选购成功', {
        confirmButtonText: '立即发布',
        cancelButtonText: '稍后发布',
        type: 'success',
        center: true,
        customClass: 'message-box'
      })
        .then(() => {
          if (value === 2) {
            window.open(Vue.prototype.liantongUrl)
          } else {
            if (type && type === 'yiwu') {
              window.open(Vue.prototype.adminUrl + `#/yiwu/login`)
            } else {
              window.open(`${Vue.prototype.adminUrl}#/authorize?accessToken=${accessToken}&townId=${townId}`)
            }
          }
        })
      if (callback) callback()
    } else {
      handleError(response)
    }

    commit({
      type: 'updateLoadingId',
      payload: null
    })
  },
  async manageApp({ commit }, { id, callback, type }) {
    const publishType = localStorage.getItem('publishType')
    const townId = localStorage.getItem('townId')
    const accessToken = localStorage.getItem('access-token')
    const { $message } = Vue.prototype
    if (!publishType || !townId || !id) {
      $message.error('参数缺失')
      return
    }
    commit({
      type: 'updateLoadingId',
      payload: id
    })
    if (type && type === 'yiwu') {
      // window.open(Vue.prototype.adminUrl + `#/yiwu/login`)
      window.open(`${Vue.prototype.adminUrl}#/authorize?accessToken=${accessToken}&townId=${townId}`)
    } else {
      window.open(`${Vue.prototype.adminUrl}#/authorize?accessToken=${accessToken}&townId=${townId}`)
    }
    if (callback) callback()
    commit({
      type: 'updateLoadingId',
      payload: null
    })
  },
  async getHotKeyword({ commit }, payload) {
    const response = await getHotKeyword(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateHotKeyword', payload: (response.data) || [] })
    }
  },
  async getBannerPage({ commit }, payload) {
    const response = await getBannerPage(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateBannerPage', payload: (response.data.list) || [] })
    }
  },
  async getBannerList({ commit }, payload) {
    const response = await getBannerList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateBannerList', payload: (response.data) || [] })
    }
  },
  async getCommercialList({ commit }, payload) {
    const response = await getCommercialList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateCommercialList', payload: (response.data.list) || [] })
    }
  },
  async getModulesList({ commit }, payload) {
    const response = await getModulesList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateModulesList', payload: (response.data) || [] })
    }
  },
  async getSearch({ commit }, payload) {
    const response = await getSearch(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateSearchResult', payload: (response.data.list) || [] })
    }
  },
  async getSearchSolution({ commit }, payload) {
    const response = await getSearchSolution(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateSolutionResult', payload: (response.data.list) || [] })
    }
  },
  async getChannelByCode({ commit }, payload) {
    const response = await getChannelByCode(payload)
    if (response && response.code === '0') {
      document.title = response.data.channelName
      commit({ type: 'updateChannelByCode', payload: (response.data) || {} })
    }
  },
  async getSolutionDetail({ commit }, payload) {
    const response = await getSolutionDetail(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateSolutionInfo', payload: (response.data) || {} })
    } else if (response.code === '100001') {
      // 方案被下架
      router.push('/404')
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/home.js